<template>
    <div class="splash" :class="{ fadeout: !isLoading }">
        <app-logo class="splash__logo" :theme-switch="true" />
    </div>
</template>

<script>
import AppLogo from '@/components/shared/app-logo';

export default {
    name: 'loading-screen',
    components: { AppLogo },

    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss">
.splash {
    @extend %fill;
    position: fixed;
    z-index: 9999;
    color: var(--app-color);
    background-color: var(--app-backgroundColor);
    display: flex;
    justify-content: center;
    align-items: center;

    &__logo {
        width: 450px;
    }
}

.fadeout {
    animation: fadeout 0.1s forwards;
}

@keyframes fadeout {
    50% {
        opacity: 1;
    }
    100% {
        opacity: 0;
        visibility: hidden;
    }
}
</style>
